module.exports = __webpack_public_path__ + "static/Danzza-Bold-e943ff2069d5fe3fa14214d3aca76741.woff";